import React from 'react';
import { PostResponseSchema } from '@/api/client';
import { EventMarkerSvg } from './EventMarkerSvg';
import { LiveMarkerSvg } from './LiveMarkerSvg';
import { RecordedMarkerSvg } from './RecordedMarkerSvg';
import { ThumbnailMarkerSvg } from './ThumbnailMarkerSvg';
import {
  getEventBackgroundColor,
  getLivestreamBackgroundColor,
  isLivestreamReplay,
  MARKER_COLORS,
} from './markerUtils';

interface MapMarkerProps {
  post: PostResponseSchema;
  isHighlighted?: boolean;
}

export const MapMarker: React.FC<MapMarkerProps> = ({ post, isHighlighted = false }) => {
  const thumbnailUrl = (post as any).marker_thumbnail;

  switch (post.post_type) {
    case 'event':
      return <EventMarkerSvg backgroundColor={getEventBackgroundColor(post)} />;

    case 'livestream':
      return (
        <LiveMarkerSvg
          backgroundColor={getLivestreamBackgroundColor(post)}
          isReplay={isLivestreamReplay(post)}
        />
      );

    case 'recorded':
    default:
      if (thumbnailUrl) {
        return <ThumbnailMarkerSvg thumbnailUrl={thumbnailUrl} iconName={post.icon || 'newspaper'} isHighlighted={isHighlighted} />;
      }
      return (
        <RecordedMarkerSvg
          iconName={post.icon || 'newspaper'}
          backgroundColor={MARKER_COLORS.recorded}
          isHighlighted={isHighlighted}
        />
      );
  }
};
